function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7229 3.19391C13.1135 2.80318 13.6433 2.58361 14.1958 2.5835H21.6667C22.2192 2.5835 22.7491 2.80299 23.1398 3.19369C23.5305 3.58439 23.75 4.1143 23.75 4.66683V12.1377C23.7499 12.6902 23.5303 13.22 23.1396 13.6106L14.0729 22.6772C13.5995 23.1477 12.9591 23.4118 12.2917 23.4118C11.6242 23.4118 10.9839 23.1477 10.5104 22.6772L3.65625 15.8231C3.18578 15.3496 2.92173 14.7093 2.92173 14.0418C2.92173 13.3744 3.18578 12.734 3.65625 12.2606L12.7229 3.19391Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0202 8.83366C17.7325 8.83366 17.4993 8.60047 17.4993 8.31283C17.4993 8.02518 17.7325 7.79199 18.0202 7.79199C18.3078 7.79199 18.541 8.02518 18.541 8.31283C18.541 8.60047 18.3078 8.83366 18.0202 8.83366Z",
    fill: "#1A4338",
    stroke: "#1A4338",
    style: {
      fill: "#1A4338",
      fill: "color(display-p3 0.1020 0.2627 0.2196)",
      fillOpacity: 1,
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.386a671d7170b075710011f6b8410e85.svg";
export { ForwardRef as ReactComponent };